import User from "../user/user";

class LoginModalHelper {

    /**
     * Binds input data to user class.
     * 
     * @param user: User
     * @returns User
     */
    static bind(user) {

        user.username = String($('.user-username').val());
        user.password = String($('.user-password').val());

        return user;
    };

    /**
     * Clears input data and user class.
     * 
     * @returns void
     */
    static clearloginInputs() {
        $('.user-username').val('');
        $('.user-password').val('');
        $('.login-error-block').empty();
    };

    /**
     * Shows login errors.
     * 
     * @param error string
     */
    static logErorr(error) {
        var translation = window['langArr'][window['language']];
        if (error === 'Error: Authentication failed') {
          $('.login-error-block').html(translation['auth_failed']);
        } else {
          $('.login-error-block').html(error);
        }
    }

    /**
     * Close modal.
     *
     * @returns void.
     */
    static closeModal() {
        $('.login-modal').modal('hide');
    }
}

export default LoginModalHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/helpers/login-modal-helper.js
// module id = 325
// module chunks = 4